/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function PaginationPreviousIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 -1 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_2112_522" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_2112_522)">
        <path d="M6.14423 10.625L10.4519 14.9327C10.5759 15.0566 10.637 15.2017 10.6354 15.3678C10.6338 15.5339 10.5684 15.6816 10.4391 15.8109C10.3098 15.9316 10.1635 15.9941 10 15.9984C9.83656 16.0027 9.6902 15.9402 9.56094 15.8109L4.27729 10.5272C4.19931 10.4493 4.14429 10.367 4.11223 10.2804C4.08018 10.1939 4.06415 10.1004 4.06415 10C4.06415 9.89958 4.08018 9.8061 4.11223 9.71957C4.14429 9.63303 4.19931 9.55076 4.27729 9.47278L9.56094 4.18913C9.67631 4.07374 9.8192 4.01472 9.98961 4.01205C10.16 4.00938 10.3098 4.06841 10.4391 4.18913C10.5684 4.3184 10.633 4.4669 10.633 4.63463C10.633 4.80237 10.5684 4.95087 10.4391 5.08013L6.14423 9.37503H15.625C15.8023 9.37503 15.9508 9.43486 16.0705 9.55451C16.1902 9.67416 16.25 9.82266 16.25 10C16.25 10.1774 16.1902 10.3259 16.0705 10.4455C15.9508 10.5652 15.8023 10.625 15.625 10.625H6.14423Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default PaginationPreviousIcon;
